import firebase from '@firebase/app';
import '@firebase/auth';

const config = {
  apiKey: "AIzaSyAX_hkFpXOfLzf5NWOVdvqLctPsaX3NdQ8",
  authDomain: "student-coach-e1e95.firebaseapp.com",
  databaseURL: "https://student-coach-e1e95.firebaseio.com",
  projectId: "student-coach-e1e95",
  storageBucket: "student-coach-e1e95.appspot.com",
  messagingSenderId: "418860883682",
  appId: "1:418860883682:web:0523db7bb5bb01e9"
};
firebase.initializeApp(config);

export default firebase
export const firebaseAuth = firebase.auth!();